import moment from "moment";
import {DEFAULT_BACKEND_URL, DEFAULT_FRONT_END_URL} from "../helpers/env";
export const config = {
  env: "local",
  dbpref: "maep_",
  version: require("../../package.json").version,
  local: {
    url: `${DEFAULT_BACKEND_URL}/maep/v1/`,
    imageBaseUrl: `${DEFAULT_BACKEND_URL}`,
    admin: `${DEFAULT_FRONT_END_URL}`,
  },
  dev: {
    url: `${DEFAULT_BACKEND_URL}/maep/v1/`,
    imageBaseUrl: `${DEFAULT_BACKEND_URL}`,
    web:`${DEFAULT_FRONT_END_URL}`,
  },
  prod: {
    url: `${DEFAULT_BACKEND_URL}/maep/v1/`,
    imageBaseUrl: `${DEFAULT_BACKEND_URL}`,
    web: `${DEFAULT_FRONT_END_URL}`,
  },
};

export const app = {
  version: require("../../package.json").version,
};

export const initialize = () => {
  if (window.location.host.match(/localhost/i)) {
    config.env = "local";
  } else if (window.location.host === "maep.esoko.com") {
    config.env = "dev";
  } else {
    config.env = "prod";
  }
};

export const dates = {
  yr: moment().format("YYYY"),
};

// ::: storage
export const setStorage = (key, value) => {
  if (key && value) {
    localStorage.setItem(config.dbpref + key, value);
  }
};
export const getStorage = (key) => {
  const value = localStorage.getItem(config.dbpref + key);
  return value || "";
};
export const setStorageJson = (key, value) => {
  if (key && value) {
    localStorage.setItem(config.dbpref + key, JSON.stringify(value));
  }
};
export const getStorageJson = (key) => {
  if (key) {
     const value = localStorage.getItem(config.dbpref + key);
       return JSON.parse(value) || "";
  }
};
export const delStorage = (key) => {
  if (key) {
    localStorage.removeItem(config.dbpref + key);
  }
};

export const redirect = (to) => {
  window.location = to;
};

export const generateOptions = (length, step = 1) => {
  const arr = [];
  for (let value = 0; value < length; value += step) {
    arr.push(value);
  }
  return arr;
};

export const numberFormat = (number, minimumFractionDigits = 0) => {
  return new Intl.NumberFormat("en-US", { minimumFractionDigits }).format(
    number
  );
};

export const randNum = (length = 6) => {
  var result = "";
  var characters = "0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const randCode = (length = 6) => {
  var result = "";
  var characters = "ABCDEFGHJKMNOPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const imgError = (e) => {
  e.target.src = "/assets/default.png";
};
